import { BASEURL } from '../../utilites';
import axios from 'axios';
import { COURSE_ACTION_TYPE } from './Type';

const getStartedCourse = () => {
	return async (dispatch) => {
        dispatch({
					type: COURSE_ACTION_TYPE.getStartedCourseFetchingStart,
				});
		axios
			.get(`${BASEURL}/api/resourcecenter/courses/get-started`)
			.then((response) => {
				dispatch({
					type: COURSE_ACTION_TYPE.getStartedCourseFetchingSuccess,
                    payload:{
                        status:true,
                        message:'Success',
                        data:response.data?.data
                    }
				});
			})
			.catch((error) => {
				dispatch({
					type: COURSE_ACTION_TYPE.getStartedCourseFetchingSuccess,
					status: false,
					message:
						error.code === 'ERR_NETWORK'
							? error?.message
							: error?.response?.data?.error?.raw?.message
							? error?.response?.data?.error?.raw?.message
							: error?.response?.data?.error,
				});
			});
	};
};



export const course = {
    getStartedCourse
};
